/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { store } from '@core/store';

export class IndexedPriceByDemand extends DaoModel {
  constructor(demandType, price, modification_author) {
    super();
    this.demandType = demandType;
    this.price = this.getPriceLabel(price) || null;
    this.modificationAuthor = modification_author || null;
  }

  getPriceLabel(price) {
    const { currency } = store.getters;
    const symbolPosition = currency ? currency.symbolPosition : '';
    const leftSymbol = symbolPosition === 'left' ? currency.symbol : '';
    const rightSymbol = symbolPosition === 'right' ? currency.symbol : '';
    return `${leftSymbol}${price}${rightSymbol}`;
  }
}
